export const PARTNER_RESPONSE_TRAVEL_COST_ACCEPTABLE_MAX = 65;
export const PARTNER_RESPONSE_ESCALATION_EMAIL = 'sd.management@nscglobal.com';
export const PARTNER_FE_ACCOUNT_REQUEST_EMAIL = 'servicedesk@nscglobal.com';
export const PARTNER_RESPONSE_SLA_EXCEPTION_CLIENT_KEYWORDS = ['parkland'] as const;
export const PARTNER_CLIENT_NOTIFICATION_SKIP_CLIENT_KEYWORDS = ['flash global'] as const;
export const PARTNER_CLIENT_NOTIFICATION_EBOND_ACTIONS = [
  {
    clientKeyword: 'at t',
    fieldName: 'ATTActionDo',
    fieldValue: 'SendNote',
  },
  {
    clientKeyword: 'nutanix',
    fieldName: 'NutanixActionDo',
    fieldValue: 'SendWorkNote',
  },
  {
    clientKeyword: 'getec',
    fieldName: 'GETECActionDo',
    fieldValue: 'SendWorkNote',
  },
] as const;

export const PARTNER_SCHEDULING_OTRS_FESTATUS_FE_ASSIGNED = 'assigned';
export const PARTNER_SCHEDULING_OTRS_FESTATUS_FE_TO_ASSIGN = 'notassigned';

export const PARTNER_IMPORT_STALE_RUNNING_MINUTES_DEFAULT = 120;
